import { BeaconErrorType } from '@airgap/beacon-types';
import { BeaconError } from './BeaconError';
/**
 * @category Error
 */
export class ParametersInvalidBeaconError extends BeaconError {
    name = 'ParametersInvalidBeaconError';
    title = 'Parameters Invalid';
    constructor() {
        super(BeaconErrorType.PARAMETERS_INVALID_ERROR, 'Some of the parameters you provided are invalid and the request could not be completed. Please check your inputs and try again.');
    }
}
//# sourceMappingURL=ParametersInvalidBeaconError.js.map